import { GoogleCookieConsentStatus } from '../types/CookieConsent';

export const getTargetCookieUserConsentStatus = (
  categories: string[],
  targetCookie: string,
): GoogleCookieConsentStatus => {
  return categories.includes(targetCookie) ? 'granted' : 'denied';
};
